export default __webpack_public_path__ + "static/media/guinness-logo-light.7dffe426.svg";